import { useCallback, useState } from 'react'

export const useDialog = () => {
  const [cancelConfirm, setCancelConfirm] = useState<boolean>(false)
  const [deleteConfirm, setDeleteConfirm] = useState<boolean>(false)
  const [uiState, setUiState] = useState<boolean>(false)

  const [actualResult, setActualResult] = useState<boolean>(false)
  const [taskUuid, setTaskUuid] = useState<string>()

  const openCancelConfirm = useCallback(() => setCancelConfirm(true), [])
  const closeCancelConfirm = useCallback(() => setCancelConfirm(false), [])

  const openDeleteConfirm = useCallback(() => setDeleteConfirm(true), [])
  const closeDeleteConfirm = useCallback(() => setDeleteConfirm(false), [])

  const openActualResult = useCallback(
    (uuid: string) => {
      setTaskUuid(uuid)
      setActualResult(true)
    },
    [actualResult, taskUuid]
  )

  const closeActualResult = useCallback(() => {
    setActualResult(false)
    setTaskUuid(undefined)
  }, [actualResult, taskUuid])

  const openUiState = useCallback(() => setUiState(true), [])
  const closeUiState = useCallback(() => setUiState(false), [])

  return {
    cancelConfirm,
    openCancelConfirm,
    closeCancelConfirm,

    deleteConfirm,
    openDeleteConfirm,
    closeDeleteConfirm,

    actualResult,
    taskUuid,
    openActualResult,
    closeActualResult,

    uiState,
    openUiState,
    closeUiState,
  }
}
